import { render, staticRenderFns } from "./PayrollCode.vue?vue&type=template&id=212a820e&scoped=true&"
import script from "./PayrollCode.vue?vue&type=script&lang=js&"
export * from "./PayrollCode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "212a820e",
  null
  
)

export default component.exports